<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Разрешения на охоту') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg bgw-pdg-20">
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <Menu/>
          </div>
        </div>
        <div class="search-head">
          <v-row>
            <v-col>
              <v-label>{{ $t('Организация') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="oopts"
                  item-value="id"
                  item-text="transName"
                  v-model="search.oopt"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Год') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="refYears"
                  item-value="year"
                  item-text="transName"
                  v-model="search.year"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col>
              <v-label>{{ $t('Номер') }}</v-label>
              <v-text-field
                v-model="search.number"
                outlined
                dense
                clearable
              />
            </v-col>
          </v-row>
          <div class="search-action">
            <button
              class="btn btn-default green-grassy"
              @click="applicationList()"
            >
              {{ $t('Поиск') }}
            </button>
            <button
              class="btn btn-default gray"
              @click="search = {}, applicationList()"
            >
              {{ $t('Очистить') }}
            </button>
          </div>
        </div>
        <div class="search-body">
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="td-num">{{ $t('Пп') }}</td>
                <td class="text-center">
                  <div class="sort-flex">
                    {{ $t('Охотхозяйство') }}
                    <a @click="sort('oopt')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'number' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td class="text-center">
                  <div class="sort-flex">
                    {{ $t('Исх. №') }}
                    <a @click="sort('number')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'number' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Тип заявки') }}
                    <a @click="sort('type')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'type' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>{{ $t('Данные заявки') }}</td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Статус и дата присвоения') }}
                    <a @click="sort('status')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'status' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(application, i) in applications" :key="i"
                  :class="{ unread: !application.applicationPermitView }">
                <td class="td-num">{{ i + 1 }}</td>
                <td class="text-center">{{ application.ooptName }}</td>
                <td class="text-center">{{ application.number }}</td>
                <td class="text-center">{{ application.typeName }}</td>
                <td>
                  <router-link :to="{ name: 'license-application-view', params: { id: application.id } }">
                    {{ $t('Заявка от') }} {{ new Date(application.date) | dateFormat('DD.MM.YYYY') }}
                  </router-link>
                </td>
                <td>
                  <span>{{ application.statusName }}</span> <br>
                  <span v-if="application.lastHistory">{{
                      new Date(application.lastHistory.date) | dateFormat('DD.MM.YYYY HH:mm')
                    }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
            v-model="page"
            :length="paginationData.pageCount"
            total-visible="10"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Menu from '@/components/license/Menu'
import Quota from '@/model/quota'
import License from '@/model/license'

export default {
  components: {
    Menu
  },
  data: () => ({
    search: {},
    applications: [],
    breadcrumbs: [],
    oopts: [],
    refYears: [],
    page: 1,
    paginationData: {},
    sortParams: {
      field: 'date',
      order: 'DESC'
    }
  }),
  watch: {
    page () {
      this.applicationList(false)
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.getQuotaApplicationFilterData()
        .then((res) => {
          this.oopts = res.data.oopts
          this.refYears = res.data.refYears
          this.applicationList()
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.generateBreadcrumbs()
      this.setLoading(false)
    },
    applicationList (resetPage = true) {
      this.setLoading(true)
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      License.listApplication(this.search).then((response) => {
        this.applications = response.data.items
        this.paginationData = response.data.paginationData
        this.setLoading(false)
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
        this.setLoading(false)
      })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.applicationList()
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на охоту'),
          disabled: true
        }
      ]
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
